export class AppStateManager {
    constructor(appStateService) {
        this.appStateService = appStateService;
    }
    resetToSystemDefault() {
        if (!this.appStateService)
            return;
        this.appStateService.resetToSystemDefaultState();
    }
    deserialize(state) {
        if (!this.appStateService)
            return {};
        return this.appStateService.deserialize(this.appStateService.serialize(state));
    }
}
